module.exports = __webpack_public_path__ + "img/chat_icon_teriatry_white.1ef63d95.svg";